import axios from "axios";
import { Product, ProductImage } from "../types/Product";
import { Media } from "../types/Media";
import { config } from "../config/environment";

const api = axios.create({
  baseURL: config.api.baseUrl,
  timeout: config.api.timeout,
});

// Generic API functions
export const get = async (url: string) => {
  return await api.get(url);
};

export const post = async (url: string, data: any, config?: any) => {
  return await api.post(url, data, config);
};

export const put = async (url: string, data: any, config?: any) => {
  return await api.put(url, data, config);
};

export const patch = async (url: string, data: any, config?: any) => {
  return await api.patch(url, data, config);
};

export const deleteRequest = async (url: string) => {
  return await api.delete(url);
};

// For backward compatibility
export { deleteRequest as delete };

export const getProducts = async (): Promise<Product[]> => {
  const response = await api.get("/products");
  return response.data;
};

export const getProduct = async (id: number): Promise<Product> => {
  const response = await api.get(`/products/${id}`);
  return response.data;
};

export const createProduct = async (
  product: Omit<Product, "id">
): Promise<Product> => {
  const response = await api.post("/products", product);
  return response.data;
};

export const updateProduct = async (
  id: number,
  product: Partial<Product>
): Promise<Product> => {
  const response = await api.put(`/products/${id}`, product);
  return response.data;
};

export const deleteProduct = async (id: number): Promise<void> => {
  await api.delete(`/products/${id}`);
};

export const uploadImages = async (
  files: File[]
): Promise<{ urls: string[] }> => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("images", file);
  });

  const response = await api.post("/upload-multiple", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const deleteImage = async (
  productId: number,
  imageId: number
): Promise<void> => {
  await api.delete(`/products/${productId}/images/${imageId}`);
};

export const getImageUrl = (path: string): string => {
  if (!path) return "";
  if (path.startsWith("http")) return path;

  // Use direct API domain for uploads - ini yang benar
  const baseUrl = "https://api.putra-agrisukses.com";

  // If path starts with /uploads/, it's a direct upload path
  if (path.startsWith("/uploads/")) {
    return `${baseUrl}${path}`;
  }

  // If path doesn't start with /, add /uploads/ prefix
  if (!path.startsWith("/")) {
    return `${baseUrl}/uploads/${path}`;
  }

  // For other paths, use as is
  return `${baseUrl}${path}`;
};
